export const widgetFontFamilies = [
  'Georgia',
  'Palatino Linotype',
  'Palatino',
  'Times New Roman',
  'Times',
  'serif',
  'Arial',
  'Helvetica',
  'Comic Sans MS',
  'cursive',
  'Lucida Sans Unicode',
  'Lucida Grande',
  'Tahoma',
  'Trebuchet MS',
  'Verdana',
  'Geneva',
  'sans-serif',
].sort()
